<template>
  <el-dialog width="520px" title="邀请成员" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="inviteVisible">
    <div class="details">
        <div class="top" v-if="status == 1">
          <h5>邀请成员加入 **********公司  <span class="template_color"  @click="handleClickRefresh()">刷新</span></h5>
          <p>可通过以下方式邀请其他用户加入本企业，邀请有效期至 <br>2024.12.31 12:00:00</p>
          <div class="invite_code">
            <p>企业邀请码</p>
            <p>外部用户可通过输入企业</p>
            <p>邀请码加入该企业</p>
            <div>ANPQ EJGE <span class="template_color" @click="handleClickCopy('ANPQ EJGE')">复制企业邀请码</span></div>
          </div>
        </div>
        <div class="bottom">
          <h5>邀请设置</h5>
          <div class="field">
            <span style="margin-right: 24px">当前企业邀请状态</span>
            <el-radio-group v-model="status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </div>
          <h5>邀请邀请码</h5>
          <div class="field">
            3天后过期
          </div>
          <p>邀请生效后的有效期，过期后无法再通过该邀请加入</p>
        </div>
    </div>

  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import {mapState} from "vuex";
export default {
  name: 'invite_members',
  props: {
    inviteVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      status:1,
    }
  },
  created() {

  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  mounted() {

  },
  methods: {

    // 刷新
    handleClickRefresh(){

    },
    // 复制
    handleClickCopy(value){
      const textToCopy = value;
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      // 选中文本并复制
      textarea.select();
      document.execCommand('copy');
      // 移除临时元素
      document.body.removeChild(textarea);
      this.$message({
        showClose: true,
        message: '复制成功',
        type: 'success',
        duration: 1500,
        onClose: () => { }
      });
    },

    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:inviteVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}

.details{
  width: 100%;
  .top{
    width: 100%;
    h5{
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      line-height: 22px;
      position: relative;
      padding-right: 40px;
      box-sizing: border-box;
      span{
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        font-weight: 500;
      }
    }
    p{
      margin-top: 8px;
      line-height: 22px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }
    .invite_code{
      width: 100%;
      padding: 16px 0;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      p{
        margin-top: 8px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
      }
      div{
        font-size: 18px;
        line-height: 26px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
        margin-top: 8px;
        span{
          cursor: pointer;
          font-weight: 500;
          margin-left: 24px;
          font-size: 14px;
        }
      }
    }
  }
  .bottom{
    width: 100%;
    h5{
      line-height: 22px;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      margin: 16px 0;
    }
    div.field{
      line-height: 22px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }
    p{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
      line-height: 22px;
      margin-top: 8px;
    }
  }
}

</style>
